import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mytasks');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mytasks',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mytasks/view.scss */
/* src/app/page.mytasks/view.scss: no such file or directory */`],
})
export class PageMytasksComponent implements OnInit {
    public loading: boolean = true;
    public notificationLoading: boolean = true;
    public actionTaskId: string = "";
    public actionNotificationId: string = "";
    public payload: any = null;
    public notificationPayload: any = null;
    public uiPolicy: any = {
        solo_admin_mode: true,
        solo_admin_applies: false
    };
    public items: any[] = [];
    public notifications: any[] = [];
    public accessError: string = "";
    public notificationError: string = "";
    public filters: any = {
        status: "",
        priority: "",
        task_type: "",
        recruitment_id: ""
    };
    public notificationFilters: any = {
        status: "UNREAD"
    };

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.loadNotifications();
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.accessError = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("get_my_tasks", this.filters);
        if (code === 200 && data?.ok !== false) {
            this.payload = data;
            this.updateUiPolicy(data);
            this.items = data.items || [];
        } else {
            this.payload = null;
            this.items = [];
            this.accessError = this.safeErrorMessage(code, message || data?.message, "내 업무 목록 조회 중 오류가 발생했습니다.");
        }

        this.loading = false;
        await this.service.render();
    }

    public async loadNotifications() {
        this.notificationLoading = true;
        this.notificationError = "";
        await this.service.render();

        const { code, data, message } = await wiz.call("get_notifications", this.notificationFilters);
        if (code === 200 && data?.ok !== false) {
            this.notificationPayload = data;
            this.updateUiPolicy(data);
            this.notifications = data.items || [];
        } else {
            this.notificationPayload = null;
            this.notifications = [];
            this.notificationError = this.safeErrorMessage(code, message || data?.message, "알림 목록 조회 중 오류가 발생했습니다.");
        }

        this.notificationLoading = false;
        await this.service.render();
    }

    public statusOptions() {
        return this.payload?.statuses || [{ key: "", label: "전체" }];
    }

    public priorityOptions() {
        return this.payload?.priorities || [{ key: "", label: "전체" }];
    }

    public taskTypeOptions() {
        return this.payload?.task_types || [{ key: "", label: "전체" }];
    }

    public notificationStatusOptions() {
        return this.notificationPayload?.statuses || [
            { key: "", label: "전체" },
            { key: "UNREAD", label: "읽지 않음" },
            { key: "READ", label: "읽음" },
            { key: "DISMISSED", label: "숨김" },
        ];
    }

    public unreadNotificationCount() {
        return this.notificationPayload?.counts?.unread || this.payload?.notifications?.unread_count || 0;
    }

    public async applyFilters() {
        await this.load();
    }

    public async resetFilters() {
        this.filters = { status: "", priority: "", task_type: "", recruitment_id: "" };
        await this.load();
    }

    public async applyNotificationFilters() {
        await this.loadNotifications();
    }

    public async completeTask(item: any) {
        if (!item?.id || this.actionTaskId) return;
        this.actionTaskId = item.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("complete_task", { task_id: item.id });
        this.actionTaskId = "";
        if (code === 200 && data?.ok !== false) {
            await this.load();
            await this.loadNotifications();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "업무 완료 처리 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async dismissTask(item: any) {
        if (!item?.id || this.actionTaskId) return;
        this.actionTaskId = item.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("dismiss_task", { task_id: item.id });
        this.actionTaskId = "";
        if (code === 200 && data?.ok !== false) {
            await this.load();
            await this.loadNotifications();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "업무 숨김 처리 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async markNotificationRead(item: any) {
        if (!item?.id || this.actionNotificationId) return;
        this.actionNotificationId = item.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("mark_notification_read", { notification_id: item.id });
        this.actionNotificationId = "";
        if (code === 200 && data?.ok !== false) {
            await this.loadNotifications();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "알림 읽음 처리 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public async dismissNotification(item: any) {
        if (!item?.id || this.actionNotificationId) return;
        this.actionNotificationId = item.id;
        await this.service.render();

        const { code, data, message } = await wiz.call("dismiss_notification", { notification_id: item.id });
        this.actionNotificationId = "";
        if (code === 200 && data?.ok !== false) {
            await this.loadNotifications();
            return;
        }

        await this.service.modal.error(this.safeErrorMessage(code, message || data?.message, "알림 숨김 처리 중 오류가 발생했습니다."));
        await this.service.render();
    }

    public openDetail(item: any) {
        if (!item?.detail_url) return;
        location.href = item.detail_url;
    }

    public updateUiPolicy(data: any) {
        const policy = data?.ui_policy || data?.permissions?.ui_policy || null;
        if (policy) this.uiPolicy = { ...this.uiPolicy, ...policy };
    }

    public soloAdminMode() {
        return !!this.uiPolicy?.solo_admin_mode && !!this.uiPolicy?.solo_admin_applies;
    }

    public compactStatusLabel(label: any) {
        const text = String(label || "").trim();
        if (!text) return "";
        if (text.includes("권한")) return text;
        if (/담당자 확인 필요|관리자 확인 필요|관리자 확정 필요|수동검토 필요|기준 확정 필요/.test(text)) return "확인 필요";
        if (text.includes("자동 산정 초안")) return "초안";
        return text;
    }

    public displayLabel(label: any) {
        return this.soloAdminMode() ? this.compactStatusLabel(label) : label;
    }

    public taskTitle(item: any) {
        const title = item?.title || "";
        return this.soloAdminMode() ? this.compactStatusLabel(title) : title;
    }

    public safeErrorMessage(code: number, message: string, fallback: string) {
        if (code === 403) return "권한이 필요합니다.";
        const text = String(message || "").trim();
        if (!text || /Traceback|File \"|\/opt\/|storage_key|file_path|<html/i.test(text)) return fallback;
        return text.length > 140 ? `${text.slice(0, 140).trim()}...` : text;
    }

    public badgeClass(status: any) {
        const value = String(status || "");
        if (["COMPLETED", "READ"].includes(value)) return "bg-emerald-50 text-emerald-700 border border-emerald-200";
        if (["DISMISSED"].includes(value)) return "bg-zinc-100 text-zinc-500 border border-zinc-200";
        if (["URGENT", "HIGH", "UNREAD"].includes(value)) return "bg-rose-50 text-rose-700 border border-rose-200";
        if (["IN_PROGRESS", "NORMAL"].includes(value)) return "bg-amber-50 text-amber-700 border border-amber-200";
        return "bg-zinc-50 text-zinc-600 border border-zinc-200";
    }
}

export default PageMytasksComponent;